// @flow

import ActiveConfigActions from '../actions/ActiveConfigActions';
import WebApi from '../WebApi';

let ActiveConfigSource = {
	fetchConfig() {
		return {
			remote(state) {
				return WebApi.getActiveConfig();
			},
			
			local() {
				return null;
			},
			
			success: ActiveConfigActions.fetchConfigDone,
			error: ActiveConfigActions.fetchConfigFailed
		};
	}
};

export default ActiveConfigSource;
